export class DataClaimTotalComponent {
    private readonly text: any;
    private readonly numberRenderer: Function;

    constructor(private element: HTMLElement) {
        this.text = $(element).data("text");
        this.numberRenderer = $.fn.dataTable.render.number(",", ".", 2, "£").display as Function;
    }

    update(value: number) {
        $(this.element).text(this.text.replace("{0}", this.numberRenderer(value)));
    }
}